import {useReducer, useCallback} from "react"
import {
    INITIAL_STATE_MODAL_CETIP_ESIN,
    CONFIG_MODAL_CETIP_ESIN,
} from "../constants/full-list-cetip-isin.const"

const reducer = {
    SET_SELECT: (state, payload) => ({...state, selectCetipIsin: payload}),
    SET_RENDA_FIXA_CARACTERISTICA_ID: (state, payload) => ({...state,  rendaFixaCaracteristicasID: payload}),
    SET_LOADING: (state, payload) => ({
        ...state,
        isLoadingModalData: payload,
    }),
    SET_LOADING_TABLE: (state, payload) => ({
        ...state,
        isLoadingTableData: payload,
    }),
    SET_ROWS: (state, payload) => ({
        ...state,
        rows: payload.rows,
        count: payload.count,
        lastFetched: Date.now(),
    }),
    TOGGLE_MODAL: (state) => ({
        ...state,
        listFullModalVisible: !state.listFullModalVisible,
    }),
}

function modalReducer(state, action) {
    const fn = reducer[action.type]
    return fn ? fn(state, action.payload) : state
}

export function useCetipModal(emissaoService) {
    const [state, dispatch] = useReducer(
        modalReducer,
        INITIAL_STATE_MODAL_CETIP_ESIN
    )

    const searchListCetip = useCallback(
        async (value = "", {limit = 50, offset = 0} = {}) => {
            const res = await emissaoService.loadEmissoes(value, {
                limit,
                offset,
            })

            return res.body
        },
        [emissaoService]
    )

    const loadFullListCetipIsin = useCallback(
        async ({limit = 50000, offset = 0} = {}, loadData) => {
            loadData ? dispatch({type: "SET_LOADING_TABLE", payload: true}) :
                dispatch({type: "SET_LOADING", payload: true})

            try {
                const {results, count} = await searchListCetip("", {limit, offset,})
                const rows = results?.map((obj, i) => ({...obj, id: offset + i,}))
                dispatch({type: "SET_ROWS", payload: {rows, count}})
            } finally {
                dispatch({type: "SET_LOADING", payload: false})
                dispatch({type: "SET_LOADING_TABLE", payload: false})
            }
        },
        [searchListCetip]
    )

    const handleOpenModal = useCallback(async () => {
        dispatch({type: "TOGGLE_MODAL"})
        const expired =
            !state.lastFetched ||
            Date.now() - state.lastFetched > CONFIG_MODAL_CETIP_ESIN.cacheTime
        if (expired) {
            await loadFullListCetipIsin()
        }
    }, [state.lastFetched, loadFullListCetipIsin])

    const handleRowClick = (params) => {
        const selectedValue = params?.row?.CETIP ?? params?.row?.ISIN
        const rendaFixaCaracteristicasID = params?.row?.ID ?? null

        dispatch({type: "SET_SELECT", payload: selectedValue})
        dispatch({type: "SET_RENDA_FIXA_CARACTERISTICA_ID", payload: rendaFixaCaracteristicasID})
        dispatch({type: "TOGGLE_MODAL"})
    }

    return {
        state,
        dispatch,
        handleOpenModal,
        handleRowClick,
        loadFullListCetipIsin,
        callBackOnChangeInputHeader: (payload) => {
            dispatch({
                type: "SET_SELECT",
                payload: payload?.selectedValue ?? "",
            })

            if (payload?.rendaFixaCaracteristicasID !== undefined) {
                dispatch({
                    type: "SET_RENDA_FIXA_CARACTERISTICA_ID",
                    payload: payload.rendaFixaCaracteristicasID,
                })
            }
        },
    }
}
